
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: "cargo-query-plan",
components:{Popup},
data(){
return{
show:true,
wrapperHeight:0,
allLoaded:false,
config:{
title:'要货计划待办',
url:'api/requireGoodsOrder/page',
workflowSearchBean:{},
property: "createdDate",
fixRules:{
rules: [{
field: "state",
option: "IN",
values: ['confirming']
}],
fixed: true
},
inputCondition:{
placeholder:'物料编号/名称',
searchCondition:'key',
rules:[{field:"requireGoodsOrderDts.matName-requireGoodsOrderDts.matCode", option: "LIKE_ANYWHERE",collectIndex:0}]
}
},
list:[],
popupShow:false,
showDetail:{}
}
},
methods:{
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function() {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
},
goCargoDetail(id){
this.$router.push('/cargo/view/'+ id);
},
viewDetail(item){
this.popupShow = true;
this.showDetail = item;
}
},
created(){
if(this.$store.state.userType == 1){
this.config.fixRules.rules[0].values = ["draft"]
}
},
mounted(){
this.init();
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/cargo-plan/cargo-query-plan-todo.vue